import { defineStore } from "pinia";
import { ref } from "vue";

export const useTabSurveyStore = defineStore("survey_tabs", () => {
    const STORAGE_KEY_TABS = "survey_tabs";
    const STORAGE_KEY_CURRENT_TAB = "survey_current_tab";
    const STORAGE_KEY_TYPE = "survey_type";

    const tabs = ref(null);
    const current = ref(null);
    const type = ref('');

    getTabs();
    getCurrent();
    getType();

    function resetTabs() {
        localStorage.setItem(STORAGE_KEY_TABS, JSON.stringify({}));
        tabs.value = {};
    }

    function resetCurrent() {
        localStorage.setItem(STORAGE_KEY_CURRENT_TAB, JSON.stringify({}));
        current.value = {};
    }

    function resetType() {
        localStorage.setItem(STORAGE_KEY_CURRENT_TAB, '');
        type.value = '';
    }

    function resetAll() {
        resetTabs();
        resetCurrent();
        resetType;
    }

    function getTabs() {
        const localData = localStorage.getItem(STORAGE_KEY_TABS);
        const data = JSON.parse(localData) ?? {};
        tabs.value = data;
        return data;
    }

    function getCurrent() {
        const localData = localStorage.getItem(STORAGE_KEY_CURRENT_TAB);
        const data = JSON.parse(localData) ?? {};
        current.value = data;
        return data;
    }

    function getType() {
        const localData = localStorage.getItem(STORAGE_KEY_TYPE);
        const data = localData ?? '';
        type.value = data;
        return data;
    }

    function setTabs(data) {
        localStorage.setItem(STORAGE_KEY_TABS, JSON.stringify(data));
        tabs.value = data;
    }

    function setCurrent(data) {
        localStorage.setItem(STORAGE_KEY_CURRENT_TAB, JSON.stringify(data));
        current.value = data;
    }

    function setType(data) {
        localStorage.setItem(STORAGE_KEY_TYPE, data);
        type.value = data;
    }

    return {
        tabs,
        current,
        type,
        resetAll,
        resetTabs,
        resetCurrent,
        resetType,
        setTabs,
        setCurrent,
        setType
    };
});
